<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK -->
        <div class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">9. Dodatkowe informacje</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">
            <textarea class="form-control" rows="4" v-model="additionalInfo" placeholder="Wpisz dodatkowe informacje..."></textarea>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['update:modelValue'])

const additionalInfo = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const sectionCollapse = ref(false)
const toggleSection = () => {
    sectionCollapse.value = !sectionCollapse.value
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>